module.exports = __webpack_public_path__ + "static/media/app-config.ae2dc657.png";